import {
	Dialog,
	FormattedText,
	Toolbar
} from "client/Components";
import { useDataInputDialog } from "client/Hooks";
import { clearDmsCache } from "client/Api/Documents/SharePoint/sharepointDocuments";
import { localize } from "client_legacy/ndaw/culture";
import { reloadCurrentPage } from "client_legacy/ndaw/navigator";
import {
	ReactElement,
	useCallback,
	useState
} from "react";
import { navigateToWorkspace } from "../Workspace/routing";

export const DocumentsInitializationFailedDialog = (): ReactElement => {
	const [isBusy, setIsBusy] = useState<boolean>(false);

	const retryHandler = useCallback(
		async (): Promise<void> => {
			setIsBusy(true);

			try {
				await clearDmsCache();
			} catch (e) {
				console.error(e);
			}

			reloadCurrentPage();
		},
		[]
	);

	const backToWorkspaceHandler = useCallback(
		(): void => {
			navigateToWorkspace();
		},
		[]
	);

	return (
		<Dialog
			trackingId="dms-initialization-failed-dialog"
			hasBusyIndicator={isBusy}
		>
			<Dialog.Header title={localize("_DocumentsInitializationFailedTitle")} />

			<Dialog.Body>
				{/* Using FormattedText here so the line endings are converted to html breaks */}
				<FormattedText
					text={localize("_DocumentsInitializationFailedBody")}
					thingsToReplace={[]}
				/>
			</Dialog.Body>

			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						kind="primary"
						text={localize("_TryAgain")}
						trackingId="try-again"
						onClick={retryHandler}
					/>

					<Toolbar.Button
						kind="secondary"
						text={localize("_BackToWorkspace")}
						trackingId="back-to-workspace"
						onClick={backToWorkspaceHandler}
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
DocumentsInitializationFailedDialog.displayName = "DocumentsInitializationFailedDialog";

export function useDocumentsInitializationFailedDialog(): [
	element: ReactElement | null,
	open: () => Promise<void>
] {
	const [element, originalOpen] = useDataInputDialog<{}, void>(
		() => (
			<DocumentsInitializationFailedDialog />
		)
	);

	const open = useCallback(
		async (): Promise<void> => {
			await originalOpen({});
		},
		[originalOpen]
	);

	return [element, open];
}
